export function msCalciatori(data) {
    const output = {};
  
    for (let key in data.calciatori) {
      if (data.calciatori.hasOwnProperty(key)) {
        // Create new key with "_" prefix
        const newKey = `_${key}`;
  
        // Extract and restructure the "ms2" property
        const ms2 = data.calciatori[key].ms2;
  
        // Assign the new structure to the output object
        output[newKey] = {
          ms: {
            text: ms2.text,
            style: ms2.style,
            icon: ms2.icon
          }
        };
      }
    }
    // delete output['_3174'];
    // console.log(output)
    return output;
  }